module.exports = __webpack_public_path__ + "img/datawalldsdd.b0aee1a3.jpg";